// extracted by mini-css-extract-plugin
export var aside = "side-column-new-module--aside--8d174";
export var footerList = "side-column-new-module--footerList--a3915";
export var pageIntro = "side-column-new-module--page-intro--1ddd5";